import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CustomLink from '@shared/components/customLink'

function ConditionalSliderVideosHeader({ headerTitle, data = [], getMoreLink, moreText = 'See More', children }) {
  const [selectedData, setSelectedData] = useState(data[0] || {})
  const [activeKey, setActiveKey] = useState(
    data[0]?.title?.toLowerCase() || 'all'
  )
  const moreLink = getMoreLink && selectedData?.arrayData?.length ? getMoreLink(selectedData) : null

  const handleSelect = (item) => {
    setSelectedData(item)
    setActiveKey(item?.title?.toLowerCase())
  }

  return (
    <div>
      <div className={`${styles.headerContainer} d-flex align-items-start`}>
        <div className={styles.titleWrapper}>
          <h4 className={`${styles.h4MarginBtm}`}>{headerTitle}</h4>
          <span className={styles.titleBar} />
        </div>
        <div className={`${styles.scorecardNav} scroll-list`}>
          {data.map((item, idx) => (
            <button
              key={`header-button-${idx}`}
              className={`${styles.headerButton} ${
                activeKey === item?.title?.toLowerCase() ? styles.active : ''
              }`}
              onClick={() => handleSelect(item)}
            >
              {item?.title}
            </button>
          ))}
        </div>
        {moreLink && (
          <CustomLink href={moreLink} prefetch={false}>
            <a className={styles.readMore}>{moreText} &rarr;</a>
          </CustomLink>
        )}
      </div>

      {children &&
        React.isValidElement(children) &&
        React.cloneElement(children, { selectedData })}
    </div>
  )
}

ConditionalSliderVideosHeader.propTypes = {
  headerTitle: PropTypes.string,
  data: PropTypes.array,
  getMoreLink: PropTypes.func,
  moreText: PropTypes.string,
  children: PropTypes.element
}

export default ConditionalSliderVideosHeader
